// src/components/EditGuestBillModal.jsx
import React, { useState, useEffect } from "react";
import axiosInstance from "../api/axiosInstance";
import { useAuth } from "../context/AuthContext";
import "./EditGuestBillModal.css";

const EditGuestBillModal = ({ isOpen, billing, onClose, onBillUpdated }) => {
  const { authData } = useAuth();
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Pre-populate the form with the current billing data when the modal opens.
  useEffect(() => {
    if (billing) {
      setDescription(billing.description);
      setAmount(billing.amount.toString());
    }
  }, [billing]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const parsedAmount = parseFloat(amount);
    if (!description.trim()) {
      setError("Description is required.");
      return;
    }
    if (isNaN(parsedAmount) || parsedAmount <= 0) {
      setError("Please enter a valid amount.");
      return;
    }
    setLoading(true);
    const payload = {
      // Include BilledBy in the payload using the logged-in user's name.
      GuestId: billing.GuestId,
      HotelId: authData.hotelId,
      description: description.trim(),
      amount: parsedAmount,
      billedBy: `${authData.firstName}`,
    };
    try {
      await axiosInstance.put(`/GuestBillings/${billing.billingId}`, payload);
      onBillUpdated(); // Refresh the list in the parent
      onClose();
    } catch (err) {
      console.error("Error updating guest bill:", err);
      setError("Failed to update guest bill. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Edit Guest Bill</h2>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="editDescription">Description:</label>
            <input
              id="editDescription"
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="editAmount">Amount:</label>
            <input
              id="editAmount"
              type="number"
              step="0.01"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </form>
        <button className="close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default EditGuestBillModal;
